import { render, staticRenderFns } from "./itemtipoclasificacion.vue?vue&type=template&id=96e33b7a"
import script from "./itemtipoclasificacion.vue?vue&type=script&lang=js"
export * from "./itemtipoclasificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports